import React, { useEffect, useState } from "react";
import Table from 'react-bootstrap/Table';
import { UserContextInstance, TableDataInstance } from "../instances/Instances";
import { getServicesByOrgId } from '../Services/DataServices';
import { URL } from '../Services/Url';
import { useGlobalContext } from '../context/store'
import { Toast } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';


const ServiceTable = () => {

  const [tableData, setTableData] = useState<TableDataInstance[]>([]);
  const [show, setShow] = useState(false);
  const currentUser: UserContextInstance = JSON.parse(sessionStorage.getItem('CurrentUser')!);
  const [deletedTitle, setDeletedTitle] = useState("");
  const { token, setOrgId } = useGlobalContext();
  const { setEditId } = useGlobalContext();

  //Navigation
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = async () => {
      setTableData(await getServicesByOrgId(currentUser.orgId));
    }

    loadData();

    //set global orgId
    setOrgId(currentUser.orgId);

  }, [tableData]);

  const handleEdit = (id: number) => {
    setEditId(id)
    navigate('/editService');
  }

  const handleDelete = async (id: number, deletedTitle: string) => {

    //TODO - create pop up and call it to confirm delete, then call handleDelete from within

    setDeletedTitle(deletedTitle);

    await fetch(
      `${URL}/Service/deleteServiceById?serviceid=${id}`, {
      method: "Get",
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': "application/json",
      }
    })
    setShow(true);
  }

  return (
    <>
      <Table bordered hover >
        <thead>
          <tr>
            <th>Title</th>
          </tr>
        </thead>
        <tbody>

          {tableData.map((service, idx) => (
            <tr key={idx}>
              <td>{service.title}</td>
              <td><button onClick={() => handleEdit(service.serviceId)}>Edit</button></td>
              <td><button onClick={() => handleDelete(service.serviceId, service.title)}>Delete</button></td>
            </tr>
          )
          )}
        </tbody>
      </Table>

      <Toast onClose={() => setShow(false)} show={show} delay={5000} autohide>
        <Toast.Header>
          {/* <img
    src="holder.js/20x20?text=%20"
    className="rounded me-2"
    alt=""
  /> */}
          <strong className="me-auto">Confirmation Alert</strong>
          <small>Few seconds ago</small>
        </Toast.Header>
        <Toast.Body>The {deletedTitle} service has been deleted.</Toast.Body>
      </Toast>

    </>

  );
}

export default ServiceTable;